import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {OnePaneLayoutFullWidthSection} from '@udemy/react-layout-components';
import {Skeleton} from '@udemy/react-reveal-components';

import styles from './consolidated-hero-banner.module.less';

const PEEK_POSITIONS = ['left', 'center', 'right'] as const;
const INDICATOR_DOT_COUNT = 3;

export interface ConsolidatedHeroBannerDetailSkeletonProps {
    className?: string;
}

/** Triptych placeholder shown after the flag resolves to "in experiment". */
export const ConsolidatedHeroBannerDetailSkeleton = ({
    className,
}: ConsolidatedHeroBannerDetailSkeletonProps) => {
    const {gettext} = useI18n();
    return (
        <OnePaneLayoutFullWidthSection>
            <OnePaneLayoutFullWidthSection.Content
                className={classNames(styles['consolidated-hero-banner'], className)}
            >
                <div
                    className={styles['detail-skeleton-stage']}
                    role="status"
                    aria-label={gettext('Loading hero banner')}
                >
                    <div className={styles['detail-skeleton-row']}>
                        {PEEK_POSITIONS.map((position) => (
                            <Skeleton key={position} className={styles['detail-skeleton-card']} />
                        ))}
                    </div>
                </div>
                <div className={styles['detail-skeleton-dots']} aria-hidden="true">
                    {Array.from({length: INDICATOR_DOT_COUNT}, (_, index) => (
                        <span key={index} className={styles['detail-skeleton-dot']} />
                    ))}
                </div>
            </OnePaneLayoutFullWidthSection.Content>
        </OnePaneLayoutFullWidthSection>
    );
};
